import { render, staticRenderFns } from "./writeInfoAssess.vue?vue&type=template&id=221ff45b&scoped=true"
import script from "./writeInfoAssess.vue?vue&type=script&lang=js"
export * from "./writeInfoAssess.vue?vue&type=script&lang=js"
import style0 from "./writeInfoAssess.vue?vue&type=style&index=0&id=221ff45b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ff45b",
  null
  
)

export default component.exports